<div class="mb-3">
  <div class="mb-3">
    <img class="object-cover rounded-2xl h-64 w-full mt-2"
         [src]=this.accommodation?.photoUri
         alt="{{this.accommodation.name }}">
  </div>
  <div class="flex justify-between">
    <div>
      <h4 class="mb-1.5">{{ accommodation.name }}</h4>
      <span class="text-sm text-gray-500">
        {{ getVatLabel() }}{{ accommodation?.isTaxed && vatPercentage ? ' (' + vatPercentage + '%)' : '' }}
      </span>
    </div>
    <div *ngIf="this.accommodation?.websiteUri">
      <a
        class="hover:no-underline hover:text-[#202A49] capitalize"
        href="{{
                      accommodation?.websiteUri
                    }}"
        target="_blank"
        rel="noopener noreferrer"
      >
        <nz-tag [nzColor]="'purple'">{{ 'itineraries.viewContentModal.accommodation.visitWebsite' | transloco }}</nz-tag>
      </a>
    </div>
  </div>
  <div>
    <nz-tag [nzColor]="'purple'"
    >{{ this.pax?.adults }} {{ 'itineraries.viewContentModal.common.adults' | transloco }}
    </nz-tag
    >
    <nz-tag [nzColor]="'purple'"
    >{{ this.pax?.children }} {{ 'itineraries.viewContentModal.common.children' | transloco }}
    </nz-tag
    >
    <nz-tag [nzColor]="'purple'"
    >{{ this.pax?.infants }} {{ 'itineraries.viewContentModal.common.infants' | transloco }}
    </nz-tag
    >
  </div>
</div>

<div class="grid grid-cols-3 gap-5">
  <div>
    <div class="mb-5">
      <h5>{{ 'itineraries.viewContentModal.accommodation.checkIn' | transloco }}</h5>
      <div>
        <nz-tag [nzColor]="'purple'">{{ !this.itinerary?.tour?.isDatesOptional ? (accommodation.checkIn | date: 'dd/MM/yyyy') : this.getDayWithNum(accommodation.checkIn) }}</nz-tag>
      </div>
    </div>
  </div>
  <div>
    <div class="mb-5">
      <h5>{{ 'itineraries.viewContentModal.accommodation.checkOut' | transloco }}</h5>
      <div>
        <nz-tag [nzColor]="'purple'">
          {{ !this.itinerary?.tour?.isDatesOptional ? (accommodation.checkOut | date: 'dd/MM/yyyy') : this.getDayWithNum(accommodation.checkOut) }}
        </nz-tag>
      </div>
    </div>
  </div>
  <div>
    <div>
      <h5>{{ 'itineraries.viewContentModal.accommodation.totalCost' | transloco }}</h5>
      <div>
        <nz-tag [nzColor]="'purple'">
          {{
            (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
            (totalCost | number: '1.2-2')
          }}
        </nz-tag>
      </div>
    </div>
  </div>
</div>

<div class="grid grid-cols-3 gap-5 mt-5">
  <div>
    <div>
      <h5>{{ 'itineraries.viewContentModal.accommodation.tax' | transloco }}</h5>
      <div>
        <nz-tag [nzColor]="accommodation?.isTaxed ? 'green' : 'red'">
          {{ getTaxStatusLabel() }}
        </nz-tag>
      </div>
    </div>
  </div>
  <div *ngIf="this.accommodation?.extraCost && this.accommodation.extraCost.length > 0">
    <h5>{{ 'itineraries.viewContentModal.accommodation.totalExtraCosts' | transloco }}</h5>
    <div>
      <nz-tag [nzColor]="'purple'">
        {{
          (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
          (extraCostTotal | number: '1.2-2')
        }}
      </nz-tag>
    </div>
  </div>
</div>

<nz-divider></nz-divider>
<div>
  <h5>{{ 'itineraries.viewContentModal.accommodation.hotelDescription' | transloco }}</h5>
  <div>
    <nz-tag class="whitespace-normal" [nzColor]="'purple'">{{ this.accommodation?.hotelDescription || getEmptyValue() }}</nz-tag>
  </div>
</div>

<nz-divider></nz-divider>
<div>
  <h5 class="mb-5">{{ 'itineraries.viewContentModal.accommodation.roomDetails' | transloco }}</h5>
  <table class="table-auto w-full border-collapse border border-gray-300">
    <thead>
    <tr class="bg-gray-100">
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.roomCategory' | transloco }}</th>
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.roomType' | transloco }}</th>
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.mealType' | transloco }}</th>
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.noOfRooms' | transloco }}</th>
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.roomRate' | transloco }}</th>
      <th *ngIf="accommodation?.isTaxed" class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.taxPercentage' | transloco }}</th>
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.cost' | transloco }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let room of accommodation.rooms">
      <th class="border border-gray-300 px-4 py-2">{{ room.roomCategory | titlecase }}</th>
      <td class="border border-gray-300 px-4 py-2">{{ room.roomType | titlecase }}</td>
      <td class="border border-gray-300 px-4 py-2">{{ room.mealType }}</td>
      <td class="border border-gray-300 px-4 py-2">{{ room.noOfRooms }}</td>
      <td class="border border-gray-300 px-4 py-2">
        {{
          (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
          (room.roomRate | number: '1.2-2')
        }}
      </td>
      <td *ngIf="accommodation?.isTaxed" class="border border-gray-300 px-4 py-2 text-center">
        {{ vatPercentage }}%
      </td>
      <td class="border border-gray-300 px-4 py-2">
        {{
          (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
          (room.cost | number: '1.2-2')
        }}
      </td>
    </tr>
    </tbody>
  </table>
</div>

<nz-divider></nz-divider>
<div *ngIf="accommodation?.extraCost && accommodation.extraCost.length > 0">
  <h5 class="mb-5">{{ 'itineraries.viewContentModal.accommodation.extraCosts' | transloco }}</h5>
  <table class="table-auto w-full border-collapse border border-gray-300">
    <thead>
    <tr class="bg-gray-100">
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.name' | transloco }}</th>
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.baseRate' | transloco }}</th>
      <th *ngIf="accommodation?.isTaxed" class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.vatPercentage' | transloco }}</th>
      <th class="border border-gray-300 px-4 py-2">{{ 'itineraries.viewContentModal.accommodation.cost' | transloco }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let extra of accommodation.extraCost">
      <td class="border border-gray-300 px-4 py-2">{{ extra.name }}</td>
      <td class="border border-gray-300 px-4 py-2 text-center">
        {{
          (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
          ((extra.baseRate ?? extra.cost) | number: '1.2-2')
        }}
      </td>
      <td *ngIf="accommodation?.isTaxed" class="border border-gray-300 px-4 py-2 text-center">
        {{ vatPercentage }}%
      </td>
      <td class="border border-gray-300 px-4 py-2 text-center">
        {{
          (this.isPrimaryCurrency ? currency : secondaryCurrency) + ' ' +
          (extra.cost | number: '1.2-2')
        }}
      </td>
    </tr>
    </tbody>
  </table>
</div>
<nz-divider></nz-divider>
<div>
  <h5>{{ 'itineraries.viewContentModal.common.notes' | transloco }}</h5>
  <div class="grid grid-cols-1">
    <div>
      <nz-tag class="whitespace-normal break-all" [nzColor]="'purple'">{{ accommodation.notes }}</nz-tag>
    </div>
  </div>
</div>
